import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <div className="header-content">
        <div>
          <h1>🤖 Selfic AI - HR Recruitment Agent</h1>
          <p>AI-Powered Intelligent Recruitment System</p>
        </div>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px', 
          background: '#f0f4f8', 
          padding: '10px 20px', 
          borderRadius: '12px' 
        }}>
          <div style={{
            width: '10px',
            height: '10px',
            background: '#48bb78',
            borderRadius: '50%',
            animation: 'pulse 2s infinite'
          }}></div>
          <span style={{ fontWeight: 600, color: '#4a5568' }}>AI Agent Online</span>
        </div>
      </div>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default Header;
